import { Container, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IReaderAdmin } from '../../../models/IReader';
import ReaderServiceInstance from '../../../services/ReaderService';
import OntimeTable from '../../common/OntimeTable';
import EditReaderDialog from './EditReaderDialog';
import OntimeBreadcrumb from '../../common/OntimeBreadcrumb';

const useStyles = makeStyles((theme) => ({
    table: {
        tableLayout: 'auto'
    },
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    appBarSpacer: theme.mixins.toolbar,
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    }
}));

function ReadersSetup() {
    const [readers, setReaders] = useState<IReaderAdmin[]>([]);
    const { t } = useTranslation("common");
    const [editingReader, setEditingReader] = useState<IReaderAdmin | undefined>(undefined);
    const classes = useStyles();
    const columns = [
        { id: 'readerId', numeric: false, label: t("readersSetup.readerId"), searchable: true, rowId: true },
        { id: 'assignedTo', numeric: false, searchable: true, label: t("readersSetup.assignedTo") },
        { id: 'manufacturer', numeric: false, disablePadding: true, label: t("readersSetup.manufacturer"), searchable: true },
        { id: 'model', numeric: false, disablePadding: true, label: t("readersSetup.model"), searchable: true, priority: 3 },
        { id: 'description', numeric: false, disablePadding: true, label: t("readersSetup.description"), searchable: true, priority: 3 },
    ];

    useEffect(() => {
        const source = axios.CancelToken.source();
        const fetchData = async () => {
            const readers = await ReaderServiceInstance.getReaders(source.token);
            setReaders(readers);
        }
        fetchData().catch(reason => {
            if (!axios.isCancel(reason)) {
                console.error(reason);
            }
        });
        return () => {
            source.cancel();
        };
    }, []);

    const itemClick = (event: any, circuitId: string) => {
        alert(circuitId);
    }

    const handleAdd = () => {
        const newReader: IReaderAdmin = {
            readerId: '',
            assignedTo: '',
            description: '',
            manufacturer: '',
            model: ''
        }
        setEditingReader(newReader);
    }
    const handleDelete = async (readerIds: string[]) => {
        readerIds.forEach(async (readerId) => {
            await ReaderServiceInstance.deleteReader(readerId);
        });
        const updatedReaders = [...readers.filter(c => readerIds.indexOf(c.readerId) === -1)];
        setReaders(updatedReaders);
    }
    const handleEdit = (readerId: string) => {
        if (readers) {
            const i = readers.findIndex(c => c.readerId === readerId);
            if (i !== -1) {
                setEditingReader(readers[i]);
            }
        }
    }

    const handleCompleteEdit = async (reader: IReaderAdmin) => {
        let savedReader = await ReaderServiceInstance.upsertReader(reader);
        const updatedReaders = [...readers.filter(c => c.readerId !== reader.readerId), savedReader];
        setReaders(updatedReaders);
    }

    return (<React.Fragment>
        <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            {editingReader === undefined ? (<></>) : (<EditReaderDialog
                reader={editingReader}
                onCompleteEdit={handleCompleteEdit}
                onCancelEdit={()=>setEditingReader(undefined)} />)}
            <Container maxWidth="lg" className={classes.container}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <OntimeBreadcrumb nameMap={{}} current={t('readersSetup.title')} />
                    </Grid>
                    <Grid item xs={12}>
                        <OntimeTable
                            tableItems={readers}
                            columns={columns}
                            defaultOrderColumn={"readerId"}
                            dense={false}
                            title={t("readersSetup.title")}
                            editable={true}
                            itemClick={itemClick}
                            onAdd={handleAdd}
                            onDelete={handleDelete}
                            onEdit={handleEdit}
                        >
                        </OntimeTable>
                    </Grid>
                </Grid>
            </Container>
        </main>
    </React.Fragment>);

}

export default ReadersSetup;